// src/modules/app-views/invoices/pages/Init/components/tableColumns/items/itemIpiColumn.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Typography } from 'antd';
import financialService from 'services/financialService';
import { resolveItemFontSize } from './index';

const { Text } = Typography;

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************

// Renders the IPI (industrial products tax) value column for item subtables.
function itemIpiColumn(options = {}) {
  const { size, ..._ } = options;
  const fontSize = resolveItemFontSize(size, 10);
  return {
    title: 'IPI',
    dataIndex: ['tax', 'ipi', 'value'],
    width: 60,
    align: 'right',
    sorter: (a, b) => {
      const aVal = a?.tax?.ipi?.value || a?.ipi || 0;
      const bVal = b?.tax?.ipi?.value || b?.ipi || 0;
      return aVal - bVal;
    },
    render: (_, item) => {
      const ipi = item?.tax?.ipi?.value || item?.ipi;
      if (!ipi) {
        return (
          <Text style={{ fontSize }} type="secondary">
            —
          </Text>
        );
      }
      return (
        <Text style={{ fontSize }} type="secondary">
          {financialService.formatCurrency(ipi)}
        </Text>
      );
    },
  };
}

export default itemIpiColumn;
